import { CertificateTransactionInfo } from '../../../dtos/response/certificate-transaction-info-response/certificate-transaction-info';
import { GenericResponseStatus } from '../../../models/generic-response-status';
import { Status } from '../../../models/status';
import { RootState } from '../../../state/state';

export const mpFlightTransactionFeatureKey = 'mpFlightTransaction';

export interface State extends RootState {
  mpFlightTransactionService: MPFlightTransactionServiceState;
}

export interface MPFlightTransactionServiceState {
  getCertificateCrudStatus: Status;
  certificateTransactionInfo: CertificateTransactionInfo[];
  certificateTransactionInfoStatus: GenericResponseStatus;
  certificateTransactionInfoExceptionContent?: string;
}

export const initialMPFlightTransactionServiceState: MPFlightTransactionServiceState = {
  getCertificateCrudStatus: Status.INITIAL,
  certificateTransactionInfo: [],
  certificateTransactionInfoStatus: GenericResponseStatus.UNKNOWN,
};
